import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      fontStyle: 'italic',
      fontSize: '0.8rem',
      width: '350px',
      backgroundColor: palette.common.primaryBlue,
      border: 'none',
      display: 'flex',
      gap: '10px',
      boxShadow: palette.shadows.boxInnerShadow,
      borderRadius: '10px',
      alignItems: 'center',
      padding: '5px 10px',
      marginBottom: '10px',
      cursor: 'pointer',
      color: palette.background.box,
      transition: '0.3s ease',
      transform: 'scale(1)',
      '&:hover': {
        transform: 'scale(1.1)',
        boxShadow:
          'inset 4px 4px 4px rgba(255, 255, 255, 0.45), inset 0px 4px 4px rgba(255, 255, 255, 0.45)'
      },
      '@media (max-width: 426px)': {
        width: '100%'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
